import useSWR from "swr";
import { useCreateProductServicePublicAxiosInstance } from "../../Auth/useCreateProductServicePublicAxiosInstance.ts";

export type NormasTeachingPromoDTO = {
  _id: string;
  name: string;
  description?: string;
  validFrom?: string;
  validTo?: string;
  bonuses: Array<
    | {
        type: "all_you_can_speak";
        lessonsCountedPerWeek: number;
        activeFrom?: string;
        activeTo?: string;
      }
    | { type: "extra_lessons"; extraLessons: number }
    | { type: "extra_weeks"; extraWeeks: number }
  >;
};

export function useActivePromosForProduct(
  productId: string,
  asOfDate?: string,
) {
  const { createAxiosInstance } = useCreateProductServicePublicAxiosInstance();
  const { data, isLoading } = useSWR(
    `/promos/active-for-product/${productId}${asOfDate ? `?date=${asOfDate}` : ""}`,
    async (url) => {
      const { data } = await createAxiosInstance().get<{
        promos: NormasTeachingPromoDTO[];
      }>(url);
      return data;
    },
  );

  return {
    promos: data?.promos ?? [],
    isLoading,
  };
}
